<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>新增活跃留存数据(仅统计最近2周环比)</span>
    </div>

    <el-table
      :data="tableData"
      style="width: 100%"
      border
    >
      <!--      <el-table-column-->
      <!--        prop="week"-->
      <!--        label="日期"-->
      <!--        width="200px"-->
      <!--      >-->
      <!--        <template v-slot:default="r">-->
      <!--          {{ r.row.start_date }} - {{ r.row.end_date }}-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column
        prop="week"
        label="周"
        width="180"
      >
        <template v-slot:default="r">
          <span v-if="r.row.week !== '环比'">
            {{ r.row.week }} ( {{ r.row.start_date }} - {{ r.row.end_date }})
          </span>
          <span v-else>{{ r.row.week }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="reg"
        label="周新增"
        width="200"
        align="center"
      />
      <el-table-column
        prop="login"
        label="周活跃"
        width="200"
        align="center"
      />
      <el-table-column
        prop="login_de"
        label="周活跃(德国)"
        width="200"
        align="center"
      />
      <el-table-column
        prop="login_fr"
        label="周活跃(法国)"
        width="200"
        align="center"
      />
      <el-table-column
        prop="login_us"
        label="周活跃(美国)"
        width="200"
        align="center"
      />
      <el-table-column
        prop="login_uk"
        label="周活跃(英国)"
        width="200"
        align="center"
      />
      <el-table-column
        prop="login_my"
        label="周活跃(马来)"
        width="200"
        align="center"
      />
      <el-table-column
        prop="reg_remain"
        label="新增留存(日均)"
        :formatter="numFormatter"
        width="200"
        align="center"
      />
      <el-table-column
        prop="reg_remain_de"
        label="新增留存(日均)-德"
        :formatter="numFormatter"
        width="200"
        align="center"
      />
      <el-table-column
        prop="reg_remain_fr"
        label="新增留存(日均)-法"
        :formatter="numFormatter"
        width="200"
        align="center"
      />
      <el-table-column
        prop="reg_remain_uk"
        label="新增留存(日均)-英"
        :formatter="numFormatter"
        width="200"
        align="center"
      />
      <el-table-column
        prop="ad_price"
        label="投放费用"
        align="center"
        width="200"
      />
      <el-table-column
        prop="ad_reg"
        label="投放新增"
        align="center"
        width="200"
      />
      <el-table-column
        prop="invitation"
        label="邀请数"
        align="center"
        width="200"
      />
    </el-table>
  </el-card>
</template>

<script>

import { isNumeric } from 'echarts/lib/util/number'

export default {
  name: 'WeekAct',
  data() {
    return {
      tableData: []
    }
  },
  created() {
  },
  methods: {
    init(data) {
      this.tableData = data
      if (data.length > 1) {
        const first = data[data.length - 2] // 0
        const second = data[data.length - 1] // 1
        const row = {
          week: '环比',
          reg: this.rate(first.reg, second.reg),
          login: this.rate(first.login, second.login),
          reg_remain: this.rate(first.reg_remain, second.reg_remain),
          reg_remain_de: this.rate(first.reg_remain_de, second.reg_remain_de),
          reg_remain_fr: this.rate(first.reg_remain_fr, second.reg_remain_fr),
          reg_remain_uk: this.rate(first.reg_remain_uk, second.reg_remain_uk),
          login_de: this.rate(first.login_de, second.login_de),
          login_fr: this.rate(first.login_fr, second.login_fr),
          login_us: this.rate(first.login_us, second.login_us),
          login_uk: this.rate(first.login_uk, second.login_uk),
          login_my: this.rate(first.login_my, second.login_my),
          ad_price: this.rate(first.ad_price, second.ad_price),
          ad_reg: this.rate(first.ad_reg, second.ad_reg),
          invitation: this.rate(first.invitation, second.invitation)
        }
        this.tableData.push(row)
      }
    },
    numFormatter(col, row, val) {
      if (col.week === '环比') {
        return val
      }
      return val + '%'
    },
    rate(start, end) {
      let rate = ((end - start) / start * 100).toFixed(2)
      if (!isNumeric(rate)) {
        rate = 0
      }
      if (rate > 0) {
        return <span style='color:#F56C6C'>{rate}%</span>
      } else {
        return <span style='color:#67C23A'>{rate}%</span>
      }
    }
  }
}
</script>

<style scoped>

</style>
